export const userTypeTabs = [
	{ value: 1, label: 'Nuevo consejero' },
	{ value: 2, label: 'Nuevo subdirector/Enlace' },
];

export const labelsformCounsel = (
	institutions = [],
	disableForm,
	myProfile,
	dataFile,
	profiles = [],
	disableOrgan,
	member = false
) => [
	{
		label: '*Nombre',
		name: 'nombre',
		type: 'text',
		required: true,
		column: 4,
		disabled: myProfile === true ? false : disableForm,
	},
	{
		label: '*Apellido Paterno',
		name: 'apellidoPaterno',
		type: 'text',
		required: true,
		column: 4,
		disabled: myProfile === true ? false : disableForm,
	},
	{
		label: 'Apellido Materno',
		name: 'apellidoMaterno',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
	},
	{
		label: '*Usuario',
		name: 'usuario',
		type: 'text',
		column: 4,
		disabled: true,
		required: true,
	},
	{
		label: '*Perfil',
		name: 'id_perfil',
		type: 'dropdown',
		options: [...profiles],
		disabled: true,
		required: true,
		column: 4,
	},
	{
		label: 'Teléfono',
		name: 'telefono',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
		isNumber: true,
		maxLength: 13,
	},
	{
		label: '*Correo Electrónico Principal',
		name: 'correo',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
		required: true,
		autoComplete: 'off1',
	},
	{
		label: 'Correo Electrónico 2',
		name: 'email1',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
		autoComplete: 'off2',
	},
	{
		label: 'Correo Electrónico 3',
		name: 'email2',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
		autoComplete: 'off3',
	},

	{
		label: 'Domicilio',
		name: 'domicilio',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? false : disableForm,
	},
	{
		label: 'Organización / Dependencia',
		name: 'institucionId',
		type: 'dropdown',
		options: [...institutions],
		column: 4,
		disabled:
			myProfile === true ? true : disableOrgan === false ? false : disableForm,
	},
	{
		hidden: member ? true : false,
		label: 'Cargo',
		name: 'cargo',
		type: 'dropdown',
		options: [
			{ value: 'PR', text: 'Propietario' },
			{ value: 'SU', text: 'Suplente' },
		],
		column: 4,
		disabled:
			myProfile === true ? true : disableOrgan === false ? false : disableForm,
	},
	{
		label: 'Representación',
		name: 'sector',
		type: 'dropdown',
		options: [
			{ value: 'SG', text: 'Sector Gobierno' },
			{ value: 'ST', text: 'Sector Trabajador' },
			{ value: 'SE', text: 'Sector Empresarial' },
		],
		column: 4,
		disabled:
			myProfile === true ? true : disableOrgan === false ? false : disableForm,
	},
	{
		label: 'Número de Oficio',
		name: 'oficio',
		type: 'text',
		column: 4,
		disabled:
			myProfile === true ? true : disableOrgan === false ? false : disableForm,
	},
	dataFile.idEntidad !== 0
		? {
				type: 'icon-upload_minos',
				data: dataFile,
				id: 'BtnuploadMinosArchivoOficio',
				column: 4,
				disabled:
					myProfile === true
						? true
						: disableOrgan === false
						? false
						: disableForm,
		  }
		: {},
	{
		label: `${member ? 'Miembro' : 'Integrante de Órgano Colegiado'}`,
		name: 'miembro',
		type: 'checkbox',
		column: 4,
		autoComplete: 'off3',
		disabled:
			myProfile === true ? true : disableOrgan === false ? false : disableForm,
	},
];

export const labelsformLink = (
	disableUser,
	myProfile,
	profiles = [],
	institutions,
	btnOrganV,
	member = false
) => [
	{
		label: '*Usuario',
		name: 'usuario',
		type: 'text',
		column: 4,
		disabled: myProfile === true ? true : disableUser,
		required: true,
	},
	{
		label: '*Nombre',
		name: 'nombre',
		type: 'text',
		column: 4,
		disabled: true,
		required: true,
	},
	{
		label: '*Apellido Paterno',
		name: 'apellidoPaterno',
		type: 'text',
		column: 4,
		disabled: true,
		required: true,
	},
	{
		label: 'Apellido Materno',
		name: 'apellidoMaterno',
		type: 'text',
		column: 4,
		disabled: true,
	},

	{
		label: '*Correo Electrónico',
		name: 'correo',
		type: 'text',
		column: 4,
		disabled: true,
		required: true,
	},
	{
		label: '*Perfil',
		name: 'id_perfil',
		type: 'dropdown',
		options: [...profiles],
		disabled: myProfile === true ? true : disableUser,
		required: true,
		column: 4,
	},
	{
		label: 'Unidad Administrativa',
		name: 'institucionId',
		type: 'dropdown',
		options: [...institutions],
		column: 4,
		disabled: myProfile === true ? true : btnOrganV === false ? false : disableUser,
	},
	{
		hidden: member ? true : false,
		label: 'Cargo',
		name: 'cargo',
		type: 'dropdown',
		options: [
			{ value: 'PR', text: 'Propietario' },
			{ value: 'SU', text: 'Suplente' },
		],
		column: 4,
		disabled: myProfile === true ? true : btnOrganV === false ? false : disableUser,
	},
	{
		label: `${member ? 'Miembro' : 'Integrante de Órgano Colegiado'}`,
		name: 'miembro',
		type: 'checkbox',
		column: 4,
		autoComplete: 'off3',
		disabled: myProfile === true ? true : btnOrganV === false ? false : disableUser,
	},
];

export const buttonsUser = (
	onSave,
	onCancel,
	onreturn,
	disableForm,
	myProfile,
	userInt,
	isNEew,
	onAssingOrgans,
	btnOrganV
) => [
	{
		title: 'Limpiar',
		color: 'light-primary',
		onClick: onCancel,
		className: myProfile === true ? 'd-none' : disableForm ? 'd-none' : '',
	},
	{
		title: isNEew === true ? 'Crear Usuario' : 'Actualizar Usuario',
		color: 'primary',
		onClick: onSave,
		className:
			myProfile === true
				? 'd-none'
				: btnOrganV === false
				? 'ml-4'
				: disableForm
				? 'd-none'
				: 'ml-4',
	},
	{
		title: 'Asignar Órganos',
		color: 'info',
		onClick: onAssingOrgans,
		className:
			isNEew === true
				? 'd-none'
				: btnOrganV === true
				? 'd-none'
				: myProfile === true
				? 'd-none'
				: 'ml-4',
	},
	{
		title: 'Regresar',
		color: 'light-primary',
		onClick: onreturn,
		className: myProfile === true ? 'd-none' : 'ml-4',
	},
];

//ADD ORGAN
export const labelOrgans = (organs = [], disableOrgan, myProfile) => [
	{
		label: '*Órganos Colegiados',
		name: 'organs',
		type: 'search-multiple',
		options: [...organs],
		renderOption: true,
		column: 12,
		disabled: myProfile === true ? true : disableOrgan,
	},
];

export const defaultOrgans = {
	id: '',
	organs: [],
};

export const defaultUser = {
	usuario: '',
	nombre: '',
	apellidoPaterno: '',
	apellidoMaterno: '',
	domicilio: '',
	telefono: '',
	sector: '',
	cargo: '',
	oficio: '',
	tipo: '',
	estatus: 'A',
	email1: '',
	email2: '',
	correo: '',
	institucionId: '',
	correos: [],
	id_perfil: '',
	miembro: false,
};
